<template>
  <main-wrapper>
    <back-nav :back="$t('back.back')" :title="$t('detail.title')"></back-nav>
    <detailoverview-nav :onchaindata="onchaindata" :offchaindata="offchaindata"></detailoverview-nav>
    <detailtable-nav :address="onchaindata.address" :pk="onchaindata.public_key"></detailtable-nav>
  </main-wrapper>
</template>

<script>
import MainWrapper from "common/components/MainWrapper.vue";
import DetailoverviewNav from "./components/Detailoverview";
import DetailtableNav from "./components/Detailtable";
import BackNav from "./components/Goback";
export default {
  name: "detail",
  components: {
    MainWrapper,
    DetailoverviewNav,
    DetailtableNav,
    BackNav
  },
  computed: {
    onchaindata() {
      return this.$store.getters.nodeonchaininfo || {};
    },
    offchaindata() {
      return this.$store.getters.nodeoffchaininfo || {};
    },
  },
  watch: {},
  data() {
    return {};
  },
  mounted() {
    this.getDetailOverview();
    window.scrollTo(0, 0);
  },
  methods: {
    getDetailOverview() {
      let pk = this.$route.params.pk;
      this.$store.dispatch("getNodeOnchainInfo", { pk: pk }).then();
      this.$store.dispatch("getNodeOffchainInfo", { pk: pk }).then();
    }
  },
  created() {
    if (this.$route.params.type == undefined) {
      this.$router.push({
        name: "detailtype",
        params: {
          pk: this.$route.params.pk,
          address: this.$route.params.address,
          type: "balance"
        }
      });
    }
  }
};
</script>
